(async () => {
  const { default: startEasasJs } = await import("./index");
  startEasasJs();
})();
